var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDownMore = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 26,
  fill: "none",
  viewBox: "0 0 32 26"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M16.667 9.858 11.2 5.417 9.334 7.042 16.667 13 24 7.042l-1.866-1.625zm0 6.609L11.2 12.025l-1.866 1.517 7.333 5.958L24 13.542l-1.866-1.517z",
  opacity: 0.4
})));
export { SvgDownMore as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAzMiAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgb3BhY2l0eT0iMC40Ij4KPHBhdGggZD0iTTE2LjY2NjggOS44NTgzNUwxMS4yMDAyIDUuNDE2NjlMOS4zMzM1IDcuMDQxNjlMMTYuNjY2OCAxM0wyNC4wMDAyIDcuMDQxNjlMMjIuMTMzNSA1LjQxNjY5TDE2LjY2NjggOS44NTgzNVpNMTYuNjY2OCAxNi40NjY3TDExLjIwMDIgMTIuMDI1TDkuMzMzNSAxMy41NDE3TDE2LjY2NjggMTkuNUwyNC4wMDAyIDEzLjU0MTdMMjIuMTMzNSAxMi4wMjVMMTYuNjY2OCAxNi40NjY3WiIgZmlsbD0id2hpdGUiLz4KPC9nPgo8L3N2Zz4K";